import * as React from 'react';
import clsx from 'clsx';

interface Props {
  text: string;
  className?: string;
}

const ShopDetailsChipLabel: React.FC<Props> = ({ text, className }) => {
  return (
    <p
      className={clsx(
        'bg-neutral-100 text-neutral-900 py-2 px-3 rounded-button flex items-center justify-center',
        className
      )}
    >
      {text}
    </p>
  );
};

export default ShopDetailsChipLabel;
